import store from 'dashboard/store';

import ExpertToolMain from 'dashboard/templates/views/ExpertTool/ExpertToolMain';

import sportsGoal from './sports-goal';
import safetyPrecautions from './safety-precautions';
import history from './history';
import { redirectIfBehaviourModulesAreNotEnabled } from "../../../../hooks/enabled-module-guard";

import { ROLE_EXPERT_TOOL } from 'dashboard/store/user/role-tree';

/**
 * EXPERT tool routes
 * @name router.Expert-tool
 */

export default {
  path: 'expert-tool',
  component: ExpertToolMain,
  name: 'PatientExpertTool',
  redirect: { name: 'PatientExpertToolSportsGoal' },
  meta: {
    // title: 'Patient - Expert Tool',
    title: t => `${t('people.patient')} - ${t('expertTool.title')}`,
  },
  children: [
    sportsGoal,
    safetyPrecautions,
    // Note: Release 2.0 scope reduction
    // history,
  ],
  async beforeEnter(to, from, next) {
    const currentPatientId = from.params?.patientId;
    const newPatientId = to.params?.patientId;

    // If user was redirected from page because startmoving is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["STARTMOVING"], to, next, newPatientId)){
      return
    }

    // Update user if back is used as everything stays cached in computed
    if ((currentPatientId === undefined && newPatientId) ||
        currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
    ) {
      await Promise.all([
        store.dispatch('patientSummary/get', newPatientId, {root: true}),
      ]);
    }

    await store.dispatch('expertTool/reset');
    await store.dispatch('expertTool/init');

    if (store.getters['user/isGranted'](ROLE_EXPERT_TOOL)) {
      next();
    } else {
      next(from.path);
    }
  },
};
